import React from "react";
import Photo from "../../components/faceswap/Photo";

export default function Photos() {
  return <Photo />;
}
